import { render, staticRenderFns } from "./DialogJustificativa.vue?vue&type=template&id=1d994354"
import script from "./DialogJustificativa.vue?vue&type=script&lang=js"
export * from "./DialogJustificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports